export const talledosDarkTheme = {
  colors: {
    text: '#fff',
    background: '#000',
    primary: '#E5CF99',
    secondary: '#F2D6A0',
    hover: '#333',
    muted: '#444',
    highlight: '#21130d',
    accent: 'rgba(255,245,220,0.07)',
    textMuted: 'rgba(255, 255, 255, 0.7)',
    textSubtle: 'rgba(255, 255, 255, 0.5)',
    overlay: 'rgba(0, 0, 0, 0.4)',
    shadow: '0 8px 32px rgba(0, 0, 0, 0.25)',
    shadowSm: '0 2px 8px rgba(0, 0, 0, 0.15)',
    shadowMd: '0 4px 24px rgba(0, 0, 0, 0.2)',
    surface: 'rgba(255, 255, 255, 0.05)',
    surfaceElevated: 'rgba(255, 255, 255, 0.08)',
    surfaceMuted: 'rgba(255, 255, 255, 0.03)',
    inputBorder: 'rgba(229, 207, 153, 0.3)',
    inputBorderSubtle: 'rgba(229, 207, 153, 0.15)',
    placeholder: 'rgba(255, 255, 255, 0.4)',
    error: '#ff6b6b',
    success: '#48c78e',
    onImage: '#fff',
    codeBg: '#1a1a1a',
    codeText: '#859900',
    borderSubtle: 'rgba(255, 245, 220, 0.9)',
    autofillBg: 'rgba(20, 20, 20, 1)',
    iconHover: 'rgba(0, 0, 0, 0.1)',
    badgeOnImage: 'rgba(229, 207, 153, 0.9)',
    shareDialogBg: '#f6f6f6',
    shareDialogText: '#000',
    shareDialogTextMuted: 'rgba(0, 0, 0, 0.7)',
    shareDialogHover: 'rgba(0, 0, 0, 0.1)',
    avatarBorder: '#fff',
  },
};
